import axiosInstance from './axiosInstance';

export const getStats = () => axiosInstance.get('/api/v1/admin/stats');
export const getRidesOverTime = (days = 30) =>
  axiosInstance.get('/api/v1/admin/stats/rides-over-time', { params: { days } });
export const getEarningsStats = ({ groupBy = 'day', startDate, endDate, vehicleType } = {}) =>
  axiosInstance.get('/api/v1/admin/stats/earnings', {
    params: {
      group_by: groupBy,
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
      ...(vehicleType ? { vehicle_type: vehicleType } : {}),
    },
  });
export const getHealth = () => axiosInstance.get('/api/v1/health');
